<template>
  <main class="printProposal container-fluid mf_container pb_50 mb_50">
    <div v-show="is_ready">
      <h4 class="text-green mt_22">保險規劃建議書</h4>
      <div class="printProposal__step mt_13">步驟1/3:選擇要列印的建議商品</div>
      <OperateContractItemTD
        @isReady="updateReady"
        v-if="!isLoading"
        selectedMode="checkbox"
        :contractData="proposal"
        @updateMCProdList="handleUpdate"
      ></OperateContractItemTD>
      <!-- 可選報表 -->
      <!--
    <div class="importMobile__proposalList" v-if="proposalListScope.length > 0">
      <div
        class="importMobile__proposalList__item mt_15 pb_11"
        v-for="(mc, index) in proposalListScope"
        :key="index"
      >
        <div class="checkbox checkbox-inline mr_5">
          <input
            type="checkbox"
            :id="`proposal__${index}`"
            v-model="mc.is_print"
          />
          <label :for="`proposal__${index}`"></label>
        </div>
        <div class="mr_5">建議{{ index + 1 }}:</div>
        <div>
          <div>
            {{ `${mc.prod_name}(${mc.prod_id})` }}
            <template v-if="mc.job_cat && mc.job_cat != ''">{{
              `(職業類別:${mc.job_cat}類)`
            }}</template>
          </div>
          <div v-for="(sc, index) in mc.sc_prod_list" :key="index" class="mt_5">
            └{{ `${sc.prod_name}(${sc.prod_id})` }}
            <template v-if="sc.job_cat && sc.job_cat != ''">{{
              `(職業類別:${sc.job_cat}類)`
            }}</template>
          </div>
        </div>
      </div>
    </div>
    -->
      <div class="printProposal__step mt_13">步驟2/3:選擇報表</div>
      <!-- 可選報表 -->
      <div class="text-green mt_18">
        <strong class="font-20">可選報表</strong>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(true)"
          v-show="!is_selected"
        >
          選取所有報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectAll(false)"
          v-show="is_selected"
        >
          清空所有報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectCommonlyUsed(true)"
          v-show="!is_CommonReport_selected"
        >
          選取所有常用報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          @click="selectCommonlyUsed(false)"
          v-show="is_CommonReport_selected"
        >
          清空所有常用報表
        </button>
      </div>

      <div class="printProposal__reportList">
        <div
          class="printProposal__reportList__item"
          v-for="report in sortedReportList"
          :key="report.name"
        >
          <div class="printProposal__reportList__item__main">
            <div>
              <div class="checkbox checkbox-inline mr_5">
                <input
                  type="checkbox"
                  :id="`report__${report.paraval}`"
                  :key="`report__${report.paraval}`"
                  v-model="report.is_checked"
                  class="mr_5"
                  :disabled="
                    (report.paraval == '8' && isDisabledMergeBenefitPrint) ||
                    (report.paraval == '9' && premiumFinancingRmk != '') ||
                    (report.paraval == '10' && isDisabledSpilloverPointsPrint)
                  "
                  @change="sortDragReportList"
                />
                <label :for="`report__${report.paraval}`"></label>
              </div>
              <div>{{ report.paradetlno }}</div>
              <a
                v-if="
                  !(report.paraval == '8' && isDisabledMergeBenefitPrint) &&
                  !(report.paraval == '9' && premiumFinancingRmk != '') &&
                  !(report.paraval == '10' && isDisabledSpilloverPointsPrint)
                "
                href="javascript:;"
                class="ml_10 text-green"
                @click="printProposal(report.paraval)"
                >預覽</a
              >
              <div
                v-if="report.paraval == '9'"
                class="printProposal__reportList__item__premiumFinancingRmk"
              >
                {{ premiumFinancingRmk }}
              </div>
              <div
                v-if="report.paraval == '10' && isDisabledSpilloverPointsPrint"
                class="printProposal__reportList__item__spilloverPointsRmk"
              >
                僅限符合外溢發點商品且被保險人實際年齡須達18歲(含)。
              </div>
            </div>
            <a
              role="button"
              :class="[
                'btn btn-default btn-sm btn-common mr-20',
                isCommonlyUsed(report) ? 'btn-common-active' : 'btn-common',
              ]"
              @click="setCommonlyUsed(report)"
              :disabled="
                (report.paraval == '8' && isDisabledMergeBenefitPrint) ||
                (report.paraval == '9' && premiumFinancingRmk != '') ||
                (report.paraval == '10' && isDisabledSpilloverPointsPrint)
              "
            >
              常用
              <span
                v-if="isCommonlyUsed(report)"
                :class="{
                  'circle-index': true,
                  'circle-index-disabled':
                    (report.paraval == '8' && isDisabledMergeBenefitPrint) ||
                    (report.paraval == '9' && premiumFinancingRmk != '') ||
                    (report.paraval == '10' && isDisabledSpilloverPointsPrint),
                }"
              >
                {{ getCommonlyUsedIndex(report) + 1 }}
              </span>
            </a>
          </div>
          <div
            class="printProposal__reportList__item__sub"
            v-if="
              report.paraval == '4' ||
              (report.paraval == '8' && !isDisabledMergeBenefitPrint)
            "
          >
            <div class="checkbox checkbox-inline mr_5">
              <input
                type="checkbox"
                :id="`report__reportRegular_${report.paraval}`"
                v-model="reportRegular"
                class="mr_5"
              />
              <label :for="`report__reportRegular_${report.paraval}`"></label>
            </div>
            列印至20年後，每隔5年列印至保障期滿
          </div>
        </div>
      </div>

      <div>
        <div class="text-green mt-5 font-20 rwd-mt">
          <strong>拖曳調整報表列印順序</strong>
          <button
            type="button"
            @click="initDragItemByParagrpno()"
            class="btn btn-default btn-sm"
            style="vertical-align: middle"
          >
            回復預設排序
          </button>
          <button
            type="button"
            @click="initDragItemByCommonlyUsedRp()"
            class="btn btn-default btn-sm"
            style="vertical-align: middle"
          >
            回復常用排序
          </button>
        </div>
        <div
          :key="draggableKey"
          v-if="dragReportList.length > 0"
          style="width: 50%"
        >
          <draggable
            v-model="dragReportList"
            v-bind="dragOptions"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
            item-key="paraval"
          >
            <div
              class="d-flex flex-row rwd-radio-block"
              v-for="(report, index) in dragReportList"
              :key="report.paraval"
            >
              <div class="pdf-index">{{ index + 1 }}</div>
              <div class="mr-auto pdfBtn">
                <i class="fas fa-arrows-alt text-gray mr-2"></i>
                {{ report.paradetlno }}
              </div>
            </div>
          </draggable>
        </div>
        <div v-else class="noPDFListData mt-4 rwd-mt">
          尚未選取任何報表或列印對象
        </div>
      </div>

      <div class="printProposal__step mt_13">步驟3/3:設定封面資訊</div>
      <!-- 封面樣式 -->
      <h5 class="text-green mt_18">封面樣式</h5>
      <div class="printProposal__cover row">
        <div
          :class="{ 'order-12': index == 0 }"
          v-for="(cover, index) in coverList"
          :key="cover.paraval"
          style="width: 14%; padding: 0.3%"
        >
          <div class="printProposal__cover mt_10">
            <div class="radio radio-inline mr_7">
              <input
                type="radio"
                name="printProposal__cover"
                :value="cover.paraval"
                :id="`printProposal__cover__${cover.paraval}`"
                v-model="coverSelect"
              />
              <label :for="`printProposal__cover__${cover.paraval}`"></label>
            </div>
            <div class="printProposal__cover__info">
              <div>{{ cover.name }}</div>
            </div>
          </div>
          <div class="printProposal__cover__info__pic" v-if="index != 0">
            <img :src="cover.imgURL" alt="" />
          </div>
        </div>
      </div>
      <!-- 謹致 -->
      <Sincerely
        :sincerelySelect.sync="sincerelySelect"
        :sincerely__otherTitle.sync="sincerely__otherTitle"
        :sincerely__insuredTitle.sync="sincerely__insuredTitle"
        :sincerely__insurerTitle.sync="sincerely__insurerTitle"
      />
      <!-- 服務人員資訊 -->
      <div class="d-flex align-items-center mt_15">
        <h5 class="text-green mr_5">服務人員資訊</h5>
        <a class="btn btn-default mx-2" @click="editServicePopupOpen = true">
          修改
        </a>
      </div>
      <div class="printProposal__serviceInfo mt_15">
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>保險顧問</strong>
          <div>{{ serviceInfo.agnt_name }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>服務單位</strong>
          <div>{{ serviceInfo.cevnm }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>公司電話</strong>
          <div>({{ serviceInfo.corp_tel_area }}){{ serviceInfo.corp_tel }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>行動電話</strong>
          <div>{{ serviceInfo.mobile }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>MAIL</strong>
          <div>{{ serviceInfo.email }}</div>
        </div>
      </div>
      <div class="d-flex align-items-center mt_15">
        <h5 class="text-green mr_5">服務人員資訊2</h5>
      </div>
      <div class="d-flex align-items-center mt_15">
        <section class="editServiceForm search pt_0">
          <label class="editServiceForm__inputItem mb_10">
            <span>保險顧問</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.agnt_name"
              alt="ch"
              maxlength="13"
              placeholder="最多輸入13個中文字"
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>服務單位</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.cevnm"
              maxlength="20"
              placeholder="最多輸入20個中文字"
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>公司電話</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 40px"
              v-model.trim="serviceInfoScope.corp_tel_area"
              maxlength="4"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'corp_tel_area',
              }"
              @input="
                serviceInfoScope.corp_tel_area =
                  serviceInfoScope.corp_tel_area.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
            <strong>-</strong>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 102px"
              v-model.trim="serviceInfoScope.corp_tel_Number"
              maxlength="15"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'corp_tel_Number',
              }"
              @input="
                serviceInfoScope.corp_tel_Number =
                  serviceInfoScope.corp_tel_Number.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
            <strong>#</strong>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 68px"
              v-model.trim="serviceInfoScope.crop_tel_Ext"
              maxlength="10"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'crop_tel_Ext',
              }"
              @input="
                serviceInfoScope.crop_tel_Ext =
                  serviceInfoScope.crop_tel_Ext.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_12">
            <span>行動電話</span>
            <div class="position-relative">
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.mobile"
                data-vv-name="phone"
                v-validate="'phone'"
                :class="{ 'is-invalid': errors.has(`phone`) }"
                maxlength="10"
                v-mfOnlyNumber="{
                  targetObj: serviceInfoScope,
                  targetKey: 'mobile',
                }"
                @change="checkValidate"
              />
              <span class="waring-text">
                {{ errors.first(`phone`) ? "行動電話格式有誤" : "" }}
              </span>
            </div>
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>MAIL</span>
            <div class="position-relative">
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.email"
                data-vv-name="email"
                v-validate="'email'"
                :class="{ 'is-invalid': errors.has(`email`) }"
                @change="checkValidate"
              />
              <span class="waring-text">
                {{ errors.first(`email`) ? "MAIL格式有誤" : "" }}
              </span>
            </div>
          </label>
        </section>
      </div>
      <EditServicePopup
        :open="editServicePopupOpen"
        @close="editServicePopupOpen = false"
        :serviceInfo.sync="serviceInfo"
      />
      <EmailPopup
        :open="emailPopupOpen"
        @close="emailPopupOpen = false"
        @send="sendEmailHandler($event)"
      />
      <FixedBottom>
        <template slot="@function">
          <div class="d-flex justify-content-end mr_15">
            <!-- <button
            class="btn btn-default px_5 mr_10"
            type="button"
            @click="toCreate()"
          >
            修改建議書
          </button> -->
            <router-link
              class="btn btn-default px_5 mr_10"
              to="/mf/query/queryDetail"
              >查詢其他建議書</router-link
            >
            <button
              class="btn btn-primary px_5 mr_10"
              type="button"
              @click="printProposal()"
              :disabled="!is_selected || !is_print_selected || !isValidate"
            >
              開啟PDF
            </button>
            <button
              class="btn btn-primary px_5 mr_10"
              type="button"
              @click="emailPopupOpen = true"
              :disabled="
                !is_selected ||
                $store.getters.BuTest ||
                !is_print_selected ||
                !isValidate
              "
              v-show="!this.$store.getters.IsBankUser"
            >
              發送EMAIL
            </button>
          </div>
        </template>
      </FixedBottom>
      <!-- email發送中 -->
      <MfLoading :open="emailSending" content="EMAIL發送中..." />
    </div>
    <MfLoading :open="!is_ready" content="資料讀取中..." />
  </main>
</template>

<script>
import draggable from "vuedraggable";
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import mf_Mixin from "@/desktop/views/mf/mixin";
import { getCustInfo } from "@/service";
import { mapGetters, mapActions } from "vuex";
import Sincerely from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/Sincerely.vue";
import EditServicePopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/EditServicePopup.vue";
import EmailPopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/SendEmailPopup.vue";
import OperateContractItemTD from "@/desktop/views/mf/components/OperateContractItem_TD.vue";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";

export default {
  props: ["hasQualification"],
  mixins: [mf_Mixin],
  components: {
    Sincerely,
    EditServicePopup,
    FixedBottom,
    EmailPopup,
    MfLoading,
    OperateContractItemTD,
    draggable,
  },
  data() {
    return {
      serviceInfo: {
        name: "",
        mktDeptName: "",
        depPhone: [],
        mobile: "",
        mail: "",
      },
      editServicePopupOpen: false,
      emailPopupOpen: false,
      emailSending: false,
      reportList: [],
      commonReportList: [],
      coverSelect: "0",
      sincerelySelect: "2",
      sincerely__otherTitle: "",
      sincerely__insuredTitle: "",
      sincerely__insurerTitle: "",
      coverImgMap: {
        cover1: require("@/desktop/views/mf/assets/cover/1.png"),
        cover2: require("@/desktop/views/mf/assets/cover/2.png"),
        cover3: require("@/desktop/views/mf/assets/cover/3.png"),
        cover4: require("@/desktop/views/mf/assets/cover/4.png"),
        cover5: require("@/desktop/views/mf/assets/cover/5.png"),
        cover6: require("@/desktop/views/mf/assets/cover/6.png"),
      },
      reportRegular: true, //列印至XX年後，每隔X年列印至保障期滿
      proposal: {},
      is_print_selected: true,
      is_CommonReport_selected: true,
      proposalListScope: [],
      is_ready: false,
      isLoading: true,
      isDisabledMergeBenefitPrint: false,
      isDisabledSpilloverPointsPrint: false,
      serviceInfoScope: {
        agnt_name: "",
        cevnm: "",
        corp_tel_area: "",
        corp_tel_Number: "",
        crop_tel_Ext: "",
        mobile: "",
        email: "",
      },
      isValidate: true,
      dragging: false,
      channel_type: "1",
      is_pfin_count: 0,
      premiumFinancingRmk: "",
      draggableKey: 0,
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    coverList() {
      return this.$paragrpno.cover_type.map((cover, index) => {
        return {
          ...cover,
          name: index == 0 ? "不列印封面" : `封面${index}`,
          imgURL: this.coverImgMap[cover.paradetlno],
        };
      });
    },
    is_selected() {
      return this.reportList.some((item) => {
        return item.is_checked;
      });
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    dragReportList: {
      get() {
        return this.reportList.filter((r) => r.is_checked);
      },
      set(newDragReportList) {
        let idx = 0;
        this.reportList = this.reportList.map((report) => {
          if (report.is_checked) {
            return newDragReportList[idx++];
          } else {
            return report;
          }
        });
      },
    },
    sortedReportList() {
      const chapterOrder =
        this.$paragrpno && this.$paragrpno.chapter
          ? this.$paragrpno.chapter.map(function (item) {
              return item.paraval;
            })
          : [];

      const commonReportListOrder = this.commonReportList
        ? this.commonReportList.map(function (item) {
            return item;
          })
        : [];

      const priorityList = this.reportList
        .filter((a) => this.isCommonlyUsed(a))
        .sort(
          (a, b) =>
            commonReportListOrder.indexOf(a.paraval) -
            commonReportListOrder.indexOf(b.paraval),
        );

      const normalList = this.reportList
        .filter((a) => !this.isCommonlyUsed(a))
        .sort(
          (a, b) =>
            chapterOrder.indexOf(a.paraval) - chapterOrder.indexOf(b.paraval),
        );

      return [...priorityList, ...normalList];
    },
    filteredCommonReportList() {
      return this.commonReportList.filter(
        (report) => !(this.is_pfin_count === 0 && report === "9"),
      );
    },
  },
  async mounted() {
    await this.initPage();
  },
  async activated() {
    await this.initPage();
  },
  methods: {
    sendEmailHandler($event) {
      this.emailPopupOpen = false;
      this.emailSending = true;
      this.printProposal(null, "send", $event);
    },
    selectAll(selectType) {
      this.is_CommonReport_selected = selectType;
      this.reportList.forEach((report) => {
        report.is_checked = this.isReportSelectable(report, selectType);
      });
      this.reportRegular = selectType;
    },
    selectCommonlyUsed(selectType) {
      this.is_CommonReport_selected = selectType;
      this.reportList.forEach((report) => {
        if (this.commonReportList.includes(report.paraval)) {
          report.is_checked = this.isReportSelectable(report, selectType);
        }
      });
      this.reportRegular = selectType;
    },
    sortDragReportList() {
      this.reportList = this.reportList
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
          if (a.item.is_checked === b.item.is_checked) {
            return a.index - b.index;
          }
          return b.item.is_checked - a.item.is_checked;
        })
        .map(({ item }) => item);
    },
    async setCommonlyUsed(report) {
      if (!this.isReportSelectable(report)) return false;

      const index = this.commonReportList.indexOf(report.paraval);
      if (index !== -1) {
        report.is_checked = false;
        this.commonReportList.splice(index, 1);
      } else {
        report.is_checked = true;
        this.commonReportList.push(report.paraval);
      }
      this.sortDragReportList();
      const checkedParavalString = this.commonReportList
        .filter((item) => item !== "")
        .map((item) => item)
        .join(",");

      let resInsertCommonlyUsedReport =
        await this.$mfAPI.MFA0_1000__insertOrUpdateCommonlyUsedReport({
          agentId: this.$store.state.userInfo.id,
          reportIds: checkedParavalString,
          reportType: "TD",
        });
    },
    isCommonlyUsed(report) {
      return this.commonReportList.includes(report.paraval);
    },
    getCommonlyUsedIndex(report) {
      const index = this.filteredCommonReportList.indexOf(report.paraval);
      return index;
    },
    async printProposal(chapter, mode = "print", mailForm) {
      let toPrintList = this.proposalListScope.filter((item) => {
        return item.is_checked;
      });
      //檢核日額通算
      /*
      let checkDailyCalculateRes = await this.checkDailyCalculate({
        insured_age: this.proposal.insured_age,
        mc_prod_list: toPrintList
      });
      if (!checkDailyCalculateRes) return;
      */
      //mode為開啟或寄出：print/send
      let chapter_tp_list = [];
      if (chapter) {
        chapter_tp_list = [chapter];
      } else {
        this.reportList.forEach((item) => {
          if (item.is_checked) {
            chapter_tp_list.push(item.paraval);
          }
        });
      }

      let selectedCover = this.coverList.find(
        (item) => item.paraval == this.coverSelect,
      );
      let toName = "";
      let toSalutation = "";
      switch (this.sincerelySelect) {
        case "1":
          toName = this.MfViewing.insurer.insured_name;
          toSalutation = this.sincerely__insurerTitle;
          break;
        case "2":
          toName = this.MfViewing.insured.insured_name;
          toSalutation = this.sincerely__insuredTitle;
          break;
        case "3":
          toName = this.sincerely__otherTitle;
          break;
      }

      let mc_idx_selected_list = this.proposal.mc_prod_list.map((mc) => {
        if (mc.is_checked) {
          return mc.mc_idx;
        }
      });
      let printObj = {
        prod_idx: this.MfViewing.saveData.prod_idx,
        agent_id: this.$store.state.userInfo.id,
        insured_id: this.MfViewing.saveData.insured_id,
        chapter_tp_list: chapter_tp_list,
        channel_type: this.$store.getters.UserChannelType,
        coverInfoMap: {
          cover_type: chapter ? "0" : selectedCover.paraval,
          cover_type_nm: selectedCover.paradetlno,
          name: toName,
          salutation: toSalutation,
          agent_name: this.serviceInfo.agnt_name,
          corp: this.serviceInfo.cevnm || "",
          corp_tel:
            this.serviceInfo.corp_tel_area +
            (!this.serviceInfo.corp_tel_area
              ? ""
              : "-" + this.serviceInfo.corp_tel),
          mobile: this.serviceInfo.mobile,
          email: this.serviceInfo.email,
          agent_name2: this.serviceInfoScope.agnt_name || "",
          corp2: this.serviceInfoScope.cevnm || "",
          corp_tel2:
            (this.serviceInfoScope.corp_tel_area || "") +
            (!this.serviceInfoScope.corp_tel_Number
              ? ""
              : "-" + this.serviceInfoScope.corp_tel_Number) +
            (!this.serviceInfoScope.crop_tel_Ext
              ? ""
              : "#" + this.serviceInfoScope.crop_tel_Ext),
          mobile2: this.serviceInfoScope.mobile,
          email2: this.serviceInfoScope.email,
        },
        isINV: false,
        printScopeMap: {
          separate_year: this.reportRegular ? "20" : "999", //"開始列印至"的年度
          interval_year: this.reportRegular ? "5" : "1", //間隔幾年
        },
        mc_idx_selected_list: mc_idx_selected_list,
        hasQualification: this.hasQualification,
      };
      if (mode == "print") {
        var newWindow = window.open("");
        newWindow.document.write(`
          <html style="height: 100%;">
          <head>
          <meta name="viewport" content="width=device-width, minimum-scale=0.1">
          <title>PDF LOADING...</title>
          </head>
          <body style="margin: 0px; background: #0e0e0e; height: 100%">
          <div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>
          </body></html>
      `);
        if (
          window.location.href.indexOf("localhost") !== -1 ||
          window.location.href.indexOf(process.env.VUE_APP_DEV_IP) !== -1
        ) {
          this.$mfAPI.MFR0_2000__printReport(printObj).then(function (res) {
            let file = new Blob([res.data], { type: "application/pdf" });
            let fileURL = URL.createObjectURL(file);
            newWindow.location = fileURL;
            setTimeout(() => {
              newWindow.document.title = "建議書章節預覽";
            }, 100);
          });
        } else {
          this.$mfAPI
            .MFR0_2000__printReportToFile(printObj)
            .then((response) => {
              let { header, body } = response.data;
              if (parseInt(header.status) < 0) {
                if (body && body.spillover_point_error === "1") { 
                  newWindow.close();
                  this.$toast.info({ title: header.message }); 
                } else {
                  this.$toast.info({ title: `執行失敗` });
                }
                return Promise.reject(header.message);
              } else if(this.$store.getters.IsBFF_MF){
                let targetURL = `${window.location.origin}/mid-mxf0-crm-ui/api/v1/MFR00100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              } else {
                let targetURL = `${this.$store.getters.MfPdfBaseURL}/MFR0_0100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              }
            });
        }
      } else if ((mode = "send" && mailForm)) {
        //寄出email
        this.$mfAPI
          .MFR0_2000__mailReport({
            ...printObj,
            //以下為send專屬
            receiver: mailForm.TO, //收件人信箱
            receiverName: "", //收件人
            subject: mailForm.Title, //信件標題
            receivercc: mailForm.CC, //副本信箱
            sender:
              mailForm.FROM +
              (this.$store.getters.IsBankUser
                ? "@cathaybk.com.tw"
                : "@cathaylife.com.tw"), //寄件人信箱
            isINV: false,
            channel_type: this.$store.getters.UserChannelType,
          })
          .then(({ data }) => {
            this.emailSending = false;
            if (parseInt(data.header.status) < 0) {
              // this.$toast.info({ title: data.header.message });
              if (data.body && data.body.spillover_point_error === "1") { 
                this.$toast.info({ title: data.header.message }); 
              } else {
                this.$toast.info({ title: "執行失敗" });
              }
            } else {
              this.$toast.info({ title: `發送成功!` });
            }
          })
          .catch((error) => {
            this.emailSending = false;
            // this.$toast.info({ title: `${error}` });
            this.$toast.info({ title: "執行失敗" });
          });
      }
    },
    handleUpdate(mc_prod_list) {
      this.proposalListScope = mc_prod_list;
      this.is_print_selected = false;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          this.is_print_selected = true;
        }
      });
      this.checkMergeBenefit();
      this.checkPremiumFinancing();
      this.checkSpilloverPointsReport();
    },
    updateReady() {
      this.is_ready = true;
      this.checkMergeBenefit();
      this.checkPremiumFinancing();
      this.checkSpilloverPointsReport();
    },
    checkMergeBenefit() {
      let checked_count = 0;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          checked_count++;
        }
      });
      let isDisabled = checked_count < 2;
      this.isDisabledMergeBenefitPrint = isDisabled;
      this.reportList.forEach((item) => {
        if (item.paraval == "8" && isDisabled) {
          item.is_checked = false;
        }
      });
    },
    checkPremiumFinancing() {
      //檢核保費融資章節勾選邏輯
      let checked_count = 0;
      let has_pfin = false;
      this.proposalListScope.forEach((mc) => {
        let is_pfin = mc.is_pfin || "";
        if (mc.is_checked) {
          checked_count++;
          if (is_pfin.split(",").includes(this.channel_type)) {
            has_pfin = true;
          }
        }
      });
      if (checked_count > 1 || !has_pfin) {
        this.premiumFinancingRmk = "　保費融資僅限單一可融資商品。";
        this.reportList.forEach((item) => {
          if (item.paraval == "9") {
            item.is_checked = false;
          }
        });
      } else {
        this.premiumFinancingRmk = "";
      }
    },
    // 檢核外溢點數回饋說明是否可勾選
    checkSpilloverPointsReport() {
      const isDisabled =
        !this.hasSelectedTreePointProd() ||
        !this.isAdulthood();

      this.isDisabledSpilloverPointsPrint = isDisabled;

      this.reportList.forEach((item) => {
        if (item.paraval === "10" && isDisabled) {
          item.is_checked = false;
        }
      });
    },
    async checkValidate() {
      this.isValidate = await this.$validator.validateAll();
    },
    // 判斷單一契約的主約或附約是否包含 CWP_LEVEL=2
    isTreePointContract(mc) {
      if (mc.cwp_level === "2") {
        return true;
      }

      const sc_prod_list = mc.sc_prod_list || [];
      return sc_prod_list.some((sc) => sc.cwp_level === "2");
    },
    // 整份建議書是否包含 CWP_LEVEL=2
    hasTreePointProd() {
      return this.proposalListScope.some((mc) => {
        return this.isTreePointContract(mc);
      });
    },
    // 目前勾選的契約是否包含 CWP_LEVEL=2
    hasSelectedTreePointProd() {
      return this.proposalListScope.some((mc) => {
        return mc.is_checked && this.isTreePointContract(mc);
      });
    },
    // 被保險人是否已滿18歲
    isAdulthood() {
      return (
        !isNaN(Number(this.proposal.insured_age)) &&
        Number(this.proposal.insured_age) >= 18
      );
    },
    initReportList() {
      this.reportList = this.$paragrpno.chapter;
      if (
        this.proposalListScope.length == 1 &&
        this.proposalListScope[0].oiu_ind === "1"
      ) {
        this.reportList = this.reportList.filter(
          (item) => item.paraval !== "6",
        );
      }
      const hasTreePointProd = this.hasTreePointProd();
      this.reportList = this.reportList.reduce((acc, item) => {
        if (item.paraval === "") return acc;
        if (this.is_pfin_count === 0 && item.paraval === "9") return acc;
        if (!hasTreePointProd && item.paraval === "10") return acc; 
        const report = {
          ...item,
          is_checked: this.isCommonlyUsed(item),
        };
        acc.push(report);
        return acc;
      }, []);
    },
    initDragItemByParagrpno() {
      const chapterOrder = this.$paragrpno.chapter
        .filter((item) => item.paraval !== "")
        .map((item) => item.paraval);

      this.reportList = this.reportList.slice().sort((a, b) => {
        const indexA = chapterOrder.indexOf(a.paraval);
        const indexB = chapterOrder.indexOf(b.paraval);
        return indexA - indexB;
      });
    },
    initDragItemByCommonlyUsedRp() {
      const chapterOrder =
        this.$paragrpno && this.$paragrpno.chapter
          ? this.$paragrpno.chapter.map(function (item) {
              return item.paraval;
            })
          : [];

      const commonReportListOrder = this.commonReportList
        ? this.commonReportList.map(function (item) {
            return item;
          })
        : [];
      const priorityList = this.reportList
        .filter((a) => this.isCommonlyUsed(a))
        .sort(
          (a, b) =>
            commonReportListOrder.indexOf(a.paraval) -
            commonReportListOrder.indexOf(b.paraval),
        );

      const normalList = this.reportList
        .filter((a) => !this.isCommonlyUsed(a))
        .sort(
          (a, b) =>
            chapterOrder.indexOf(a.paraval) - chapterOrder.indexOf(b.paraval),
        );

      this.reportList = [...priorityList, ...normalList];
    },
    async initPage() {
      document.ondragstart = function () {
        return true;
      };
      this.draggableKey++;
      await this.initRptCondByAPI();
      this.isLoading = false;
      this.initReportList(); //報表清單依使用者常用清單勾選
      this.sortDragReportList(); //初始化拖曳報表清單
      this.initDragItemByCommonlyUsedRp();
      await this.$nextTick();
      this.registerHanlink();
    },
    async initRptCondByAPI() {
      let res = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
        agent_id: this.$store.state.userInfo.id,
        insured_id: "",
        prod_idx: this.MfViewing.saveData.prod_idx,
      });
      this.proposal = res.proposal[0];
      this.proposalListScope = this.proposal.mc_prod_list;
      this.channel_type = this.$store.getters.UserChannelType;
      this.is_pfin_count = 0;
      this.proposalListScope.forEach((mc) => {
        let is_pfin = mc.is_pfin || "";
        if (is_pfin.split(",").includes(this.channel_type)) {
          this.is_pfin_count++;
        }
      });
      //查找登入者資訊(MF)
      let result = await this.$mfAPI.MVI0_0100_query({
        agnt_id: this.$store.state.userInfo.id,
      });
      this.serviceInfo = {
        ...result,
      };
      let resCommonlyUsedReport =
        await this.$mfAPI.MFA0_1000__queryCommonlyUsedReport({
          agentId: this.$store.state.userInfo.id,
          reportType: "TD",
        });
      if (
        resCommonlyUsedReport &&
        resCommonlyUsedReport.report_ids &&
        typeof resCommonlyUsedReport.report_ids === "string" &&
        resCommonlyUsedReport.report_ids.trim() !== ""
      ) {
        this.commonReportList = resCommonlyUsedReport.report_ids.split(",");
      } else {
        this.commonReportList = [];
      }
    },
    isReportSelectable(report, selectType = true) {
      if (!selectType) return false;

      if (report.paraval === "10" && this.isDisabledSpilloverPointsPrint) {
        return false;
      }
      if (report.paraval === "9" && this.premiumFinancingRmk !== "") {
        return false;
      }
      if (report.paraval === "8" && this.isDisabledMergeBenefitPrint) {
        return false;
      }
      return true;
    },
  },
  directives: {
    mfOnlyNumber: {
      bind: function (el, binding) {
        el.handler = function () {
          if (binding.value.targetObj && binding.value.targetKey) {
            binding.value.targetObj[binding.value.targetKey] = el.value.replace(
              /\D+/,
              "",
            );
          }
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function (el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
  beforeDestroy() {
    //關閉可拖曳
    if (process.env.NODE_ENV !== "development") {
      document.ondragstart = function () {
        return false;
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.font-20 {
  font-size: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.baseLine {
  vertical-align: baseline !important;
}
.printProposal {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__step {
    font-size: 24px;
    color: #323a45;
    font-weight: 700;
  }
  &__reportList {
    padding: 20px 0;
    &__item {
      border-bottom: solid 1px #e0e1e3;
      display: flex;
      flex-direction: column;
      padding: 12px 0 18px;
      &__main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div:first-child {
          display: flex;
          align-items: center;
        }
      }
      .btn-common {
        margin-left: auto;
        padding-top: 3px;
        padding-bottom: 3px;
        border: none;
        color: #9f9f9f;
        font-weight: 700;
      }
      .btn-common:hover {
        color: #ffffff;
        background-color: #9f9f9f;
      }
      .btn-common[disabled] {
        color: #ffffff;
        background-color: #9f9f9f;
      }

      .btn-common[disabled]:hover {
        color: #ffffff;
        background-color: #9f9f9f;
      }
      .btn-common-active {
        margin-left: auto;
        border: none;
        color: #f58818;
        font-weight: 700;
        background-color: #f5dec5;
        -webkit-transition: background-color 500ms linear;
        -ms-transition: background-color 500ms linear;
        transition: background-color 500ms linear;
      }
      .btn-common-active:hover {
        color: #ffffff;
        background-color: #ffb465;
      }
      .btn-common-active[disabled] {
        color: #ffffff;
        background-color: #9f9f9f;
      }

      .btn-common-active[disabled]:hover {
        color: #ffffff;
        background-color: #9f9f9f;
      }
      &__sub {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-left: 42px;
      }
      &__premiumFinancingRmk,
      &__spilloverPointsRmk {
        color: gray;
      }
    }
  }
  &__cover {
    width: 100%;
    display: flex;
    align-items: flex-start;
    line-height: 40px;
    &__info {
      width: 100%;
      padding-right: 40px;
      &__pic {
        width: 100%;
        border: solid 1px #707070;
        img {
          width: 100%;
          display: flex;
        }
      }
    }
  }
  &__serviceInfo {
    &__item {
      display: flex;
      align-items: center;
      strong {
        display: inline-block;
        margin-right: 10px;
        width: 64px;
        line-height: 1.38;
      }
    }
  }
  .emailSending {
    height: 172px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
  }
}

.importMobile {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__proposalList {
    padding: 20px 0;
    &__item {
      display: flex;
      align-items: flex-start;
      border-bottom: solid 1px #e0e1e3;
    }
    .checkbox input + label:before {
      margin: 0;
    }
  }
}
.pdfBtn {
  border-radius: 4px;
  display: table;
  border-radius: 4px;
  background-color: #f5f5f5;
  vertical-align: middle;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
}
.pdf-index {
  padding: 11px 5px;
  margin: 5px;
  font-size: 16px;
  text-decoration: none;
  font-weight: 600;
  width: 30px;
}
.noPDFListData {
  width: 208px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #989ca2;
}
.circle-index {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #ffa52e;
  color: white;
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 6px;
  user-select: none;
}
.circle-index-disabled {
  background-color: #919191;
  color: white;
}
</style>
